import React, { useEffect, useState } from 'react'
import { FormProvider, useForm, useFormState } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { Box, Button, Flex, Heading, VStack } from '@chakra-ui/react'

import { Input, Select } from '@/components/Form'

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import useConfig from '../useConfig'
import { ConfigCategory, ConfigType } from '../config.enum'
import dirtyValues from '@/utils/dirtyValues'
import { LoadingSection } from '@/components/Elements'

const TestingConfig = () => {
  // Hooks
  const dispatch = useDispatch()
  const methods = useForm()
  const { dirtyFields } = useFormState({ control: methods.control })

  const { useFetchConfig, useBatchUpdateConfigs, useFetchAllConfigByCategory, useUpdateTestingConfig } = useConfig()
  const { data: allTestingConfig, isLoading } = useFetchAllConfigByCategory(ConfigCategory.TESTING)
  const batchUpdateConfigs = useBatchUpdateConfigs()
  const updateTestingConfig = useUpdateTestingConfig()

  useEffect(() => {
    if (allTestingConfig.length === 0) {
      return
    }
    allTestingConfig.forEach((config) => {
      methods.setValue(config.type, config?.mainValue)
    })
  }, [allTestingConfig])

  const onSubmit = async (data) => {
    if (Object.keys(dirtyFields).length === 0) {
      console.log('[Testing Config] No Field Changed')
      return
    }

    const dirtyData = dirtyValues(dirtyFields, data)

    try {
      dispatch(showLoadingOverlay())

      await updateTestingConfig.mutateAsync(dirtyData)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  if (isLoading) {
    return <LoadingSection />
  }

  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading> Testing Config </Heading>
          </Flex>
          <Box p={5}>
            <VStack>
              <Input name={ConfigType.TESTING_EMAIL} label="Email" isRow isRequired={false} />
              <Input
                name={ConfigType.TESTING_SIGN_TECHNICAL_USER_NAME}
                label="Technical User"
                isRow
                isRequired={false}
              />
              <Input
                name={ConfigType.TESTING_SIGN_COMMERCIAL_USER_NAME}
                label="Commercial User"
                isRow
                isRequired={false}
              />
            </VStack>
            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default TestingConfig
